export const LICENSE_TYPE_LABELS: Record<string, string> = {
  self_service: 'Self Service',
  service: 'Service',
  kiosk_terminal: 'Kiosk Terminal',
}

export const licenseTypeLabel = (type: string): string =>
  LICENSE_TYPE_LABELS[type] ?? type

/** i18n key per licence origin (`licenses.origin.*`), as sent in LicenseResource.origin. */
export const LICENSE_ORIGIN_KEYS: Record<string, string> = {
  purchased: 'licenses.origin.purchased',
  invoiced: 'licenses.origin.invoiced',
  prepaid: 'licenses.origin.prepaid',
}

export const licenseOriginKey = (origin?: string | null): string | null =>
  (origin && LICENSE_ORIGIN_KEYS[origin]) || null
